<template>
    <v-row>
      <v-col cols="12">
        <v-toolbar>
          <v-toolbar-title>Belit Config</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card class="fill-height pa-3">
          <v-sheet class="overflow-y-auto">
            <template v-slot:default>
              <RequiredTests></RequiredTests>
            </template>
          </v-sheet>
          <div class="mt-5">
            <FlagFilter></FlagFilter>
          </div>
          <div class="mt-5">
            <TestTypeFilter></TestTypeFilter>
          </div>
          <v-card class="mt-5" outlined tile :loading="loadingConfig" :disabled="loadingConfig">
            <v-card-actions>
              <div class="title">Billing</div>
              <v-spacer></v-spacer>
              <SampleTestBill :customers="customers">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" color="primary" absolute bottom right fixed style="z-index:20;right:45%" large>Sample Test Bill</v-btn>
                </template>
              </SampleTestBill>
            </v-card-actions>
            <v-card-text class="pa-0 pl-3 pr-3" v-if="!loadingConfig">
              <div class="mb-3">
                <BillingPackages ref="billing_packages" :config_ref="configRef" :customers="customers"></BillingPackages>
              </div>
              <div class="mb-3">
                <BillingSeparatedLineItems ref="billing_separated_line_items" :config_ref="configRef" :customers="customers"></BillingSeparatedLineItems>
              </div>
              <div class="mb-3">
                <BillingPricing ref="billing_prices"></BillingPricing>
              </div>
              <div class="mb-3">
                <BillingTestPairs ref="billing_pairs"></BillingTestPairs>
              </div>
              <div class="mb-3">
                <BillingBundleCounts ref="billing_bundles"></BillingBundleCounts>
              </div>
              <div class="mb-3">
                <BillingSnowFlake ref="billing_specials" :customers="customers"></BillingSnowFlake>
              </div>
              <div class="mb-3">
                <BillingPromo ref="billing_promos"></BillingPromo>
              </div>
              <div class="mb-3">
                <BillingFixedPricing ref="billing_fixed" :customers="customers"></BillingFixedPricing>
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
      <v-snackbar v-model="hasChanges" top centered :timeout="-1" vertical class="pb-0" rounded="1">
        <strong class="title">Changes were made to the billing Config</strong>
        <v-card-actions class="pa-0 ma-0">
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn
                  v-on="on"
                  @click="reset()"
                  dark
                  color="error"
                  tile
                  >
                <v-icon>undo</v-icon>
              </v-btn>
            </template>
            <span>Reset changes</span>
          </v-tooltip>
<!--          <v-spacer></v-spacer>-->
<!--          <v-tooltip bottom>-->
<!--            <template v-slot:activator="{on}">-->
<!--              <v-btn-->
<!--                  v-on="on"-->
<!--              dark-->
<!--              color="orange darken-1"-->
<!--              tile-->
<!--              >-->
<!--                <v-icon>edit</v-icon>-->
<!--              </v-btn>-->
<!--            </template>-->
<!--            <span>View all config changes made</span>-->
<!--          </v-tooltip>-->
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn
                  v-on="on"
                  @click="saveChanges"
              dark
              color="success"
              tile
              >
                <v-icon>save</v-icon>
              </v-btn>
            </template>
            <span>Save Changes</span>
          </v-tooltip>
        </v-card-actions>
      </v-snackbar>
    </v-row>
</template>

<script>
export default {
    name: "index",
    components: {
      RequiredTests: () => import("@/views/Config/components/RequiredTests"),
      FlagFilter: () => import("@/views/Config/components/FlagFilter"),
      TestTypeFilter: () => import("@/views/Config/components/TestTypeFilter"),
      BillingSnowFlake: () => import("@/views/Config/components/BillingSnowFlake"),
      BillingPackages: () => import("@/views/Config/components/BillingPackages"),
      BillingPricing: () => import("@/views/Config/components/BillingPricing"),
      BillingBundleCounts: () => import("@/views/Config/components/BillingBundleCounts"),
      BillingPromo: () => import("@/views/Config/components/BillingPromo"),
      BillingTestPairs: () => import("@/views/Config/components/BillingTestPairs"),
      BillingFixedPricing: () => import('@/views/Config/components/BillingFixedPricing'),
      SampleTestBill: () => import("@/views/Config/components/SampleTestBill"),
      BillingSeparatedLineItems: () => import("@/views/Config/components/BillingSeparatedLineItems"),
    },
    data: () => ({
      showFab: true,
      loadingConfig: true,
      configError: false,
      configExists: false,
      configRef: null,
      configData: {},
      customers: [],
    }),
    computed:{
      hasChanges(){
        let packages = this.$store.$db().model('billingPackages').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).exists();
        let testPricing = this.$store.$db().model('billingTestPrices').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).exists();
        let testBundles = this.$store.$db().model('billingBundleDiscounts').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).exists();
        let testPairs = this.$store.$db().model('billingTestPairs').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).exists();
        let promos = this.$store.$db().model('billingPromotions').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).exists();
        let specials = this.$store.$db().model('billingSpecials').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).exists();
        let fixedPrices = this.$store.$db().model('billingFixedPrices').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).exists();
        let separatedItems = this.$store.$db().model('billingSeparatedItems').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).exists();

        return packages || testPricing || testBundles || testPairs || promos || specials || fixedPrices || separatedItems;
      },
    },
    mounted(){
      this.loadBelitConfig();
    },
    methods: {
      async saveChanges(){
        const packages = this.$store.$db().model('billingPackages').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).get();
        const testPrices = this.$store.$db().model('billingTestPrices').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).get();
        const testBundles = this.$store.$db().model('billingBundleDiscounts').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).get();
        const testPairs = this.$store.$db().model('billingTestPairs').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).get();
        const promos = this.$store.$db().model('billingPromotions').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).get();
        const specials = this.$store.$db().model('billingSpecials').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).get();
        const fixedPrices = this.$store.$db().model('billingFixedPrices').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).get();
        const separatedItems = this.$store.$db().model('billingSeparatedItems').query().where('$isDirty', true).orWhere('$isNew', true).orWhere('$softDelete', true).get();
        if(packages.length > 0){
          await this.$store.$db().model('billingPackages').updateBatchStore(packages);
          this.$refs.billing_packages.load();
        }
        if(testPrices.length > 0){
          await this.$store.$db().model('billingTestPrices').updateBatchStore(testPrices);
          this.$refs.billing_prices.load();
        }
        if(testBundles.length > 0){
          await this.$store.$db().model('billingBundleDiscounts').updateBatchStore(testBundles);
          this.$refs.billing_bundles.load();
        }
        if(testPairs.length > 0){
          await this.$store.$db().model('billingTestPairs').updateBatchStore(testPairs);
          this.$refs.billing_pairs.load();
        }
        if(promos.length > 0){
          await this.$store.$db().model('billingPromotions').updateBatchStore(promos);
          this.$refs.billing_promos.load();
        }
        if(specials.length > 0){
          await this.$store.$db().model('billingSpecials').updateBatchStore(specials);
          this.$refs.billing_specials.load();
        }
        if(fixedPrices.length > 0){
          await this.$store.$db().model('billingFixedPrices').updateBatchStore(fixedPrices);
          this.$refs.billing_fixed.load();
        }
        if(separatedItems.length > 0){
          await this.$store.$db().model('billingSeparatedItems').updateBatchStore(separatedItems);
          this.$refs.billing_separated_line_items.load();
        }
      },
      reset(){
        this.$refs.billing_packages.load();
        this.$refs.billing_prices.load();
        this.$refs.billing_bundles.load();
        this.$refs.billing_pairs.load();
        this.$refs.billing_promos.load();
        this.$refs.billing_specials.load();
        this.$refs.billing_fixed.load();
        this.$refs.billing_separated_line_items.load();
      },
      async loadBelitConfig(){
        try{
          this.loadingConfig =true;
          let customers = await this.$store.$db().model('customers').api().fetch({with: 'primaryName', where: {key: 'deleted_at', value: null}}, "",null,false,false);
          this.customers = customers.response.data;
          let config = await this.$firestore.collection("Configs").doc('Belit').get();
          if(config.exists){
            this.configExists = true;
            this.config = config.data();
            this.configRef = config.ref;
          }else{
            this.configExists = false;
          }
        }catch(e){
          console.log(e);
          this.configError = true;
        }finally{
          this.loadingConfig = false;
        }
      }
    }
}
</script>

<style>
.v-snack__content {
  padding-bottom: 0 !important;
}
</style>
